/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 277a008a2da46a4058079639b0e9282a */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type withPromotionsLayoutQueryVariables = {
    country: string;
};
export type withPromotionsLayoutQueryResponse = {
    readonly viewer: {
        readonly country: {
            readonly salesNumber: string | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"PromotionsLayout_viewer">;
    };
};
export type withPromotionsLayoutQuery = {
    readonly response: withPromotionsLayoutQueryResponse;
    readonly variables: withPromotionsLayoutQueryVariables;
};



/*
query withPromotionsLayoutQuery(
  $country: String!
) {
  viewer {
    ...PromotionsLayout_viewer
    country: countryByCode(code: $country) {
      salesNumber
      id
    }
  }
}

fragment PromotionsLayout_viewer on Viewer {
  ...SessionLayout_viewer
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "country"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "salesNumber",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "withPromotionsLayoutQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "country",
            "name": "countryByCode",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Country",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "PromotionsLayout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "withPromotionsLayoutQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "session",
            "storageKey": null,
            "args": null,
            "concreteType": "Session",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNumber",
                "args": null,
                "storageKey": null
              },
              (v3/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "country",
            "name": "countryByCode",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Country",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "withPromotionsLayoutQuery",
    "id": null,
    "text": "query withPromotionsLayoutQuery(\n  $country: String!\n) {\n  viewer {\n    ...PromotionsLayout_viewer\n    country: countryByCode(code: $country) {\n      salesNumber\n      id\n    }\n  }\n}\n\nfragment PromotionsLayout_viewer on Viewer {\n  ...SessionLayout_viewer\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'be0f1236ba9838e27db7612a4f165a27';
export default node;
